module.exports = __webpack_public_path__ + "img/pauli-x-root-3.a80ce1b2.svg";